import { Box, Button, TextField, Typography, IconButton, InputAdornment, Chip } from '@mui/material';
import { useEffect, useState } from 'react';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import BusinessIcon from '@mui/icons-material/Business';

const VV = {
  primary: '#3F2B96',
  secondary: '#7F5AF0',
  accent: '#00C896',
  bg: '#F7F8FC',
  border: 'rgba(63,43,150,0.12)',
  shadow: '0 4px 16px rgba(0,0,0,0.07)',
};

function Office({ office, removeOfficeLoc, officeLocations, setOfficeLocations, index }) {
  const [contact, setContact] = useState('');
  const [address, setAddress] = useState('');
  const [email_id, setEmailId] = useState('');

  useEffect(() => {
    if (contact !== office.contact || address !== office.address || email_id !== office.email_id) {
      if (contact.trim() !== '' || address.trim() !== '' || email_id.trim() !== '') {
        const newol = [...officeLocations];
        newol[index] = { contact, address, email_id };
        setOfficeLocations(newol);
      }
    }
  }, [contact, address, email_id]);

  useEffect(() => {
    setContact(office.contact || '');
    setAddress(office.address || '');
    setEmailId(office.email_id || '');
  }, [office]);

  const field = (label, value, onChange, icon) => (
    <TextField
      variant="outlined"
      fullWidth
      size="small"
      label={label}
      value={value}
      onChange={e => onChange(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            {icon}
          </InputAdornment>
        ),
      }}
      sx={{
        mb: 2,
        '& .MuiOutlinedInput-root': {
          borderRadius: '10px',
          bgcolor: VV.bg,
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: VV.secondary },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: VV.primary, borderWidth: 2 },
        },
        '& .MuiInputLabel-root.Mui-focused': { color: VV.primary },
      }}
    />
  );

  return (
    <Box
      sx={{
        border: `1px solid ${VV.border}`,
        borderRadius: '14px',
        p: 2.5,
        bgcolor: '#fff',
        boxShadow: VV.shadow,
        position: 'relative',
        transition: 'box-shadow 0.2s',
        '&:hover': { boxShadow: '0 8px 28px rgba(0,0,0,0.11)' },
      }}
    >
      {/* Header row */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <BusinessIcon sx={{ color: VV.secondary, fontSize: 18 }} />
          <Typography variant="subtitle2" sx={{ fontWeight: 700, color: VV.primary }}>
            Office {index + 1}
          </Typography>
        </Box>
        <IconButton
          size="small"
          onClick={() => removeOfficeLoc(office)}
          sx={{
            color: '#f44336',
            bgcolor: '#fff5f5',
            borderRadius: '8px',
            '&:hover': { bgcolor: '#ffebee' },
          }}
        >
          <DeleteOutlineIcon fontSize="small" />
        </IconButton>
      </Box>

      {field('Contact Number', contact, setContact, <PhoneIcon sx={{ color: VV.secondary, fontSize: 16 }} />)}
      {field('Address', address, setAddress, <LocationOnIcon sx={{ color: VV.secondary, fontSize: 16 }} />)}
      {field('Office Email', email_id, setEmailId, <EmailIcon sx={{ color: VV.secondary, fontSize: 16 }} />)}
    </Box>
  );
}

export default Office;
